import React from "react";
import Login from "./../../components/screens/login/Login";
import ExamLogin from "../../components/screens/attendExam/ExamLogin";
import { Route, Routes } from "react-router-dom";

function LoginRouter() {
	
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			{/* <Route path="/exam-login/" component={ExamLogin} /> */}
		</Routes>
	);
}

export default LoginRouter;
